import axios from "axios";
import subWeeks from "date-fns/sub_weeks";
import differenceInDays from "date-fns/difference_in_days";
//Limitless imports
import { calculateStatDates, mergePlatformStatData, calculateWeeklyStatDates } from "./ExpertStatsHelper";
import { createPlatformURL, handleSecureAjaxError, createMutationHeaders } from "../../../portal";
import { log as pilog } from "@limitless/common/utils";
export const fetchDashboardStats = (profile, options, locale, callback) => {
  const log = pilog.getLogger("ExpertStatsAPI fetchDashboardStats");
  const {
    numberOfDays,
    dailyMetrics,
    numberOfWeeks,
    weeklyMetrics
  } = options;
  const url = createPlatformURL("stats/experts");
  const stats = calculateStatDates(numberOfDays, locale);
  let dailyMetricNames = "";
  dailyMetrics.map(metric => {
    dailyMetricNames += `${metric.value},`;
  });
  const params = {
    experts: profile.userName,
    stats: dailyMetricNames.slice(0, -1),
    //eslint-disable-next-line
    day_number: stats.dayNumbers
  };
  log.debug(`Fetching dashboard stats for ${profile.userName} ${dailyMetricNames} `);
  axios.get(url, createMutationHeaders(params)).then(res => {
    if (!res.data) {
      throw new Error("Unexpected response from Stats API", res);
    } else {
      fetchLastXWeeksDashboardStats(profile, {
        metrics: weeklyMetrics,
        numberOfWeeks
      }, (weeklyMetricStats, weeklyStatsData) => {
        if (!weeklyMetricStats) {
          callback({
            hasError: true
          });
          return;
        }
        const metricsData = {};
        let metricStats;
        dailyMetrics.map(metric => {
          log.info(`Merging platform data for ${metric.value}`);
          metricStats = calculateStatDates(numberOfDays, locale);
          log.info(metricStats);
          metricsData[metric.value] = mergePlatformStatData(metricStats, res.data[0], numberOfDays, "", metric, profile, {}, {});
        });
        weeklyMetrics.map(weekMetric => {
          log.info(`Merging platform data for ${weekMetric.value}`);
          log.info(weeklyStatsData);
          metricsData[weekMetric.value] = mergePlatformStatData(weeklyMetricStats, weeklyStatsData, differenceInDays(new Date(), subWeeks(new Date(), numberOfWeeks)), "", weekMetric, profile, {}, {});
          log.info({
            result: metricsData[weekMetric.value]
          });
        });
        callback(metricsData);
      });
    }
  }).catch(error => {
    handleSecureAjaxError(error, "ExpertStatsAPI fetchDashboardStats");
    callback({
      hasError: true
    });
  });
};
const fetchLastXWeeksDashboardStats = (profile, options, callback) => {
  const log = pilog.getLogger("ExpertStatsAPI fetchLastXWeeksDashboardStats");
  const {
    numberOfWeeks,
    metrics
  } = options;
  const url = `${process.env.REACT_APP_BASE_PLATFORM_URL}${process.env.REACT_APP_STAGE}/stats/experts/${profile.userName}`;
  const lastWeek = calculateWeeklyStatDates(numberOfWeeks);
  log.debug("Last Week ", lastWeek);
  let metricNames = "";
  metrics.map(metric => {
    metricNames += `${metric.value},`;
  });
  const params = {
    view: "week",
    stats: metricNames.slice(0, -1),
    //eslint-disable-next-line
    week_number: lastWeek.weekNumbers // e.g."26-2018"
  };
  axios.get(url, createMutationHeaders(params)).then(res => {
    log.debug(res.data);
    callback(lastWeek, res.data[0]);
  }).catch(error => {
    handleSecureAjaxError(error, "ExpertStatsAPI fetchLastXWeeksDashboardStats");
    callback();
  });
};
export const fetchExpertStats = (profile, criteria, locale, callback) => {
  const {
    numberOfDays,
    metric,
    group,
    dataSetLabel
  } = criteria;
  const log = pilog.getLogger("ExpertStatsAPI fetchExpertStats");
  log.debug(`Fetching stats for ${profile.userName} ${metric} ${group}`);
  const url = createPlatformURL("stats/experts");
  const stats = calculateStatDates(numberOfDays, locale);
  //assume we'll get no data back
  stats.hasData = false;
  const params = {
    experts: profile.userName,
    stats: metric.value,
    //eslint-disable-next-line
    day_number: stats.dayNumbers
  };
  if (group !== "all") {
    //eslint-disable-next-line
    params.expert_group = group;
  }
  log.debug("url ", url);
  axios.get(url, createMutationHeaders(params)).then(res => {
    log.debug("Stats payload ", res.data[0]);
    const finalStatData = mergePlatformStatData(stats, res.data[0], numberOfDays, dataSetLabel, metric, profile, {}, {});
    log.debug("Final stat data ", finalStatData);
    callback(finalStatData.graphData);
  }).catch(error => {
    handleSecureAjaxError(error, "ExpertStatsAPI fetchExpertStats");
    callback({
      hasError: true
    });
  });
};